'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldSendOfflineMessage = undefined;

var _reselect = require('reselect');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var getShouldSendOfflineMessage = exports.getShouldSendOfflineMessage = (0, _reselect.createSelector)([_clientSelectors.getIsAgentReady, _widgetDataSelectors.getIsOnlineMode], function (isAgentReady, isOnlineMode) {
  return isAgentReady === false || !isOnlineMode;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/offlineModeSelectors.js
// module id = 212
// module chunks = 0 1